<template>
  <div class="progress-wrap">
    <div class="progress-wrap__train"></div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.progress-wrap {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 4px;
  background-color: $or-grey-medium;
  border-radius: 4px;

  &__train {
    position: absolute;
    left: 0;
    top: 0;
    width: 25%;
    height: 4px;
    animation: train 0.8s infinite linear;
    background-color: $or-blue;
    border-radius: 100%;

    @keyframes train {
      0% {
        left: -25%;
      }
      100% {
        left: 100%;
      }
    }
  }
}
</style>
